import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import MainLayout from "../shared/layouts/MainLayout";
import Tickets from "../pages/Tickets";
import Confirmation from "../pages/Confirmation";
import TicketPreview from "../pages/TicketPreview";
import QueryProvider from "../lib/query/provider";
import NotFound from "../pages/NotFound";
import AllTickets from "../pages/AllTickets";
import AdminLayout from "../shared/layouts/AdminLayout";
import FAQPage from "../pages/Faq";

export const RoutesWrapper: React.FC = () => {
  return (
    <QueryProvider>
      <Routes>
        {/* Routes that share the Navbar */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/tickets/:id" element={<Tickets />} />
          <Route path="/ticket/:orderId" element={<TicketPreview />} />
          <Route path="/confirmation" element={<Confirmation />} />
        </Route>
        <Route element={<AdminLayout />}>
          <Route
            path="/tickets/all/1098393171038083201375602"
            element={<AllTickets />}
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </QueryProvider>
  );
};
